export const isDOMElement = (value: EventTarget): value is Element => {
  return value instanceof Node && value.nodeType === Node.ELEMENT_NODE;
};
